import { useState, useEffect } from "react";

const BREAKPOINT = 1200;

export function useIsSmallScreen() {
  const [isSmall, setIsSmall] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => setIsSmall(window.innerWidth < BREAKPOINT);

    handleResize(); // sync once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isSmall;
}